import {
  WHATSAPP_TEMPLATE_LIMITS,
  WHATSAPP_BUTTON_TYPES,
  WHATSAPP_BUTTON_TYPE_ICONS,
} from '../constants/whatsappTemplateTypes';

/**
 * Configuration for WhatsApp Templates
 * Used to configure shared composables and components for WhatsApp platform
 */
export function useWhatsappConfig() {
  const config = {
    // i18n prefix for translations
    i18nPrefix: 'WHATSAPP_TEMPLATES',

    // Platform limits
    limits: WHATSAPP_TEMPLATE_LIMITS,

    // Button types
    buttonTypes: WHATSAPP_BUTTON_TYPES,
    buttonTypeIcons: WHATSAPP_BUTTON_TYPE_ICONS,

    // Field mapping (WhatsApp uses these field names)
    fieldMapping: {
      title: 'text', // WhatsApp uses 'text' instead of 'title'
      phone: 'phone_number', // WhatsApp uses 'phone_number' instead of 'phone'
      code: 'example', // WhatsApp uses 'example' instead of 'code'
    },

    // Platform-specific features
    showUrlExample: true, // WhatsApp requires URL example when URL has variables
    copyCodeShowsText: false, // Copy code buttons don't show text field in WhatsApp
    showIdField: false, // Quick reply doesn't show ID field in WhatsApp

    // Button title field for preview
    buttonTitleField: 'text',
  };

  return {
    config,
    // Expose individual values for convenience
    i18nPrefix: config.i18nPrefix,
    limits: config.limits,
    buttonTypes: config.buttonTypes,
    fieldMapping: config.fieldMapping,
  };
}
